import { Instagram, Facebook, Mail, Phone } from "lucide-react";

export default function Footer({ contacts, stores, t }) {
  return (
    <footer id="contatti" data-testid="footer" className="bg-[#1E1614] text-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-16 sm:pt-24 pb-10">
        <p
          aria-hidden="true"
          className="font-display text-[16vw] lg:text-[10rem] leading-none tracking-tight text-[#FAF7F2]/[0.07] select-none text-center"
        >
          FIORDIPANNA
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-4 sm:mt-8">
          <div>
            <img
              src="/images/logo-fiordipanna.png"
              alt="Fiordipanna dal 1994"
              className="h-10 w-auto brightness-0 invert opacity-90"
            />
            <p className="mt-5 text-sm leading-relaxed text-[#FAF7F2]/60 max-w-xs">
              {t.footer.tagline}
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href={contacts.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                aria-label="Instagram Fiordipanna"
                className="w-10 h-10 rounded-full border border-[#FAF7F2]/20 flex items-center justify-center hover:bg-[#C86D51] hover:border-[#C86D51] transition-colors duration-300"
              >
                <Instagram size={17} />
              </a>
              <a
                href={contacts.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                aria-label="Facebook Fiordipanna"
                className="w-10 h-10 rounded-full border border-[#FAF7F2]/20 flex items-center justify-center hover:bg-[#C86D51] hover:border-[#C86D51] transition-colors duration-300"
              >
                <Facebook size={17} />
              </a>
              <a
                href={`mailto:${contacts.email}`}
                data-testid="footer-email-link"
                aria-label="Email"
                className="w-10 h-10 rounded-full border border-[#FAF7F2]/20 flex items-center justify-center hover:bg-[#C86D51] hover:border-[#C86D51] transition-colors duration-300"
              >
                <Mail size={17} />
              </a>
            </div>
          </div>

          <div>
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51]">{t.footer.shops}</p>
            <ul className="mt-5 space-y-5">
              {stores.map((s) => (
                <li key={s.id} data-testid={`footer-store-${s.id}`}>
                  <p className="font-display text-lg">{s.city}</p>
                  <p className="text-sm text-[#FAF7F2]/55 mt-0.5">
                    {s.address}, {s.cap}
                  </p>
                  <a
                    href={`tel:${s.phone_tel}`}
                    className="inline-flex items-center gap-1.5 font-accent text-sm text-[#FAF7F2]/80 hover:text-[#C86D51] transition-colors mt-1"
                  >
                    <Phone size={13} /> {s.phone_display}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51]">{t.footer.contacts}</p>
            <ul className="mt-5 space-y-4 text-sm text-[#FAF7F2]/70">
              <li>
                <a href={`mailto:${contacts.email}`} className="hover:text-[#C86D51] transition-colors">
                  {contacts.email}
                </a>
              </li>
              <li>
                <a
                  href="/libro-degli-ingredienti-delle-gelaterie-fiordipanna/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-ingredienti-link"
                  className="hover:text-[#C86D51] transition-colors"
                >
                  {t.footer.book}
                </a>
              </li>
              <li className="leading-relaxed">
                {t.footer.hoursA}
                <br />
                {t.footer.hoursB}
                <br />
                <span className="text-[#C86D51]">{t.footer.closedMon}</span>
              </li>
              <li className="leading-relaxed text-[#FAF7F2]/50">{t.footer.delivery}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#FAF7F2]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#FAF7F2]/40">
          <p>© {new Date().getFullYear()} Fiordipanna · Etica Artigiana dal 1994</p>
          <p className="font-accent tracking-wider">CORNAREDO — ARESE — PERO</p>
        </div>
      </div>
    </footer>
  );
}
